
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import BtnCheckGroup from "@common/src/components/scope/btn-check-group/index.vue";
import t from "@common/src/i18n/t";

const setting = namespace("setting");
const service = namespace("service");
const common_base = namespace("common_base");

@Component({
  name: "invoiceDropdown",
  components: { BtnCheckGroup }
})
export default class ServiceView extends Vue {
  @setting.Action queryPrintTemplatesMy;
  @service.Action getUri;
  @service.Action email;
  @service.Action sms;
  @service.Action getOptionDetail;
  @service.Action selectInvoiceDetail;
  @common_base.State countryStr;
  @Prop({ default: () => {}, type: Object })
  orderData: any;
  showSelectPrintTemplate = false;
  showPreviewPrintTemplate = false;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  get isTH() {
    return this.countryStr === "TH";
  }
  @Watch("showPreviewPrintTemplate")
  onShowPreviewPrintTemplateChange(val) {
    if (val) {
      this.getOptionDetail({
        orderNo: this.orderData.orderNo
      }).then(data => {
        this.taxPrintInfo = data.data || {};
      });
    }
  }
  isCheckedVat = true;
  taxPrintInfo: any = {};
  templateOptions: any = [];
  selectedTemplateCode = "";
  printCommand = "";
  behaviorMap = {
    Email: "1",
    SMS: "2",
    Print: "3",
    Share: "4"
  };
  handleInvoiceMyCommand(command) {
    this.printCommand = command;
    this.queryPrintTemplatesMy({
      status: "1",
      behavior: this.behaviorMap[command]
    }).then(data => {
      this.templateOptions = data.data.map(item => {
        return {
          label: item.printTemplateName,
          value: item.printTemplateCode,
          enableConfirm: item.enableConfirm
        };
      });
      this.selectedTemplateCode = (this.templateOptions[0] && this.templateOptions[0].value) || "";
      this.showSelectPrintTemplate = true;
    });
  }
  // 打印是否是需要进行下一步
  get isNext() {
    const selectedTemplate = this.templateOptions.find(item => item.value === this.selectedTemplateCode);
    return selectedTemplate ? selectedTemplate.enableConfirm === "1" : false;
  }
  beforeConfirmPrint() {
    if (this.isNext) {
      this.showSelectPrintTemplate = false;
      this.showPreviewPrintTemplate = true;
    } else {
      this.handleConfirmPrint();
    }
  }
  // 记录打印等操作行为
  recordPrint() {
    this.selectInvoiceDetail({
      orderNo: this.orderData.orderNo,
      detailNoList: this.isCheckedVat ? (this.taxPrintInfo["options"] || []).map(item => item.orderDetailNo) : []
    });
  }
  handleConfirmPrint() {
    const printParams = { orderNo: this.orderData.orderNo, printTemplateCode: this.selectedTemplateCode };
    if (this.isNext) {
      Object.assign(printParams, {
        includeTax: this.isCheckedVat ? 1 : 0
      });
    }
    if (this.printCommand === "Email") {
      this.email(printParams).then(res => {
        if (res.code === "0") {
          this.$message.success(t("v210831.sent-successfully"));
          this.showSelectPrintTemplate = false;
          this.recordPrint();
        }
      });
    } else if (this.printCommand === "SMS") {
      this.sms(printParams).then(res => {
        if (res.code === "0") {
          this.$message.success(t("v210831.sent-successfully"));
          this.showSelectPrintTemplate = false;
          this.recordPrint();
        }
      });
    } else if (this.printCommand === "Print") {
      this.getUri(printParams).then(res => {
        if (res.code === "0") {
          this.showSelectPrintTemplate = false;
          window.open(res.data);
          this.recordPrint();
        }
      });
    } else if (this.printCommand === "Share") {
      this.getUri(printParams).then(res => {
        if (res.code === "0") {
          this.showSelectPrintTemplate = false;
          this.$copyText(res.data).then(() => this.$message.success(t("v210831.copy-succeeded")));
          this.recordPrint();
        }
      });
    }
  }
}
